export const ASYNC_LIST_LOADER_PROPS_DEFAULT = { hasText: true }
